import React, { Component } from 'react';

class DatAcademicos extends Component {
    state = {  }
    render() { 
        return ( <div>DatAcademicos</div> );
    }
}
 
export default DatAcademicos;


// WEBPACK FOOTER //
// ./src/views/Academicos/DatAcademicos.jsx